import { DateHelper } from "../../../../../utilities/contracts/date-helper";
import { StringHelper } from "../../../../../utilities/contracts/string-helper";

export class BillingItem {
  projectId: number;
  copyProjectId?: number;
  retrieval: string;
  costPerRetrieval: number;
  retrievalEndDate: string;
  abstraction: string;
  costPerAbstraction: number;
  abstractionEndDate: string;


  constructor(options: {
    projectId: number;
    copyProjectId?: number;
    retrieval: string;
    costPerRetrieval: number;
    retrievalEndDate: string;
    abstraction: string;
    costPerAbstraction: number;
    abstractionEndDate: string;

  }) {
    this.projectId = options.projectId;
    this.copyProjectId = options.copyProjectId;
    this.retrieval = StringHelper.clean(options.retrieval);
    this.costPerRetrieval = options.costPerRetrieval;
    this.retrievalEndDate = DateHelper.format(options.retrievalEndDate, "MM/DD/YYYY");
    this.abstraction = StringHelper.clean(options.abstraction);
    this.costPerAbstraction = options.costPerAbstraction;
    this.abstractionEndDate = DateHelper.format(options.abstractionEndDate, "MM/DD/YYYY");

  }
}
